export const STROKE_COLOR = '#000000';
export const BACKGROUND_COLOR = '#f8f6f2';
export const GUIDANCE_COLOR = 'rgba(43, 91, 100, 0.18)';
export const SAVE_LIMIT = 12;

// Initial inspiration topics for the memory drawing mode.
// Add more entries here to offer players additional drawing prompts.
export const inspirationTopics = [
  'Snake', 'Cat', 'Submarine', 'Sunflower', 'Pain', 'Cristiano Ronaldo', 'Octopus', 'Hug', 'Fountain',
  'Guitar', 'Flamengo', 'Pigeon', 'Katana', 'Cow', 'Bocycle', 'Dragon', 'The Kiss', 'Happiness',
  'Balance', 'The Thinker', 'Camel', 'Your Crush', 'Ratatouille', 'Swimming', 'Van Gogh', 'Your Boss', 
  'Lion', 'Spider', 'Voleiballl', 'High Heel Shoe', 'Chair', 'Mountain', 'Butterfly', 'Handshake', 'Clown',
  'Spider-Man', 'Dancer', 'Horse', 'Owl', 'Elephant', 'Saxophone', 'Scream (Munch)', 'Hope', 'Chaos', 'Fav Food',
  'Venecian Mask', 'Skull', 'Loneliness', 'Waterfall', 'Ship', 'Castle', 'Dad', 'Running', 'Mum', 'Mask',
  'Genitalia', 'Telescope', 'Medusa', 'Fire', 'Colosseum','Waterfall', 'Skateboard', 'Your president', 'You won the lottery',
  'Shark', 'Scorpion', 'Cactus', 'Banana', 'Pizza Slice', 'Champagne Glass', 'Wine Bottle', 'Robot', 'Karate Kick', 
  'Airplane', 'Helicopter', 'Hot Air Balloon', 'Rollercoaster', 'Toilet', 'Surfing', 'Skier', 'Snowman', 'Tiger', 'Crocodile',
  'Koi Fish', 'Cupid', 'Wings', 'Payphone', 'Boxing', 'Chess', 'Freedom', 'Addiction', 'Silence', 'Fav Person', 'Nightmare',
  'Salvador Dalí', 'Paris', 'Statue of Liberty', 'Great Wall of China', 'Taj Mahal', 'Snoop Dogg',
  'Don Quixote', 'Penguin', 'Sloth', 'Shrek', 'Simpson Character', 'Alien', 'UFO', 'Zombie', 'Ice Cream Cone', 'Hotdog', 'French Fries',
  'Toothbrush', 'Trophy', 'Fav movie', 'Fav memory', 'Your Dream House', 'Microphone', 'Violin', 'Astronaut', 'Hamburger', 
  'Italian Brainrot', 'Rainbow', 'Lightning Bolt', 'Volcano', 'Palm Tree', 'Desert', 'Egypt', 'Moai Statue', 'Tótem',
  'Tower of Pisa', 'Mount Fuji', 'Golden Gate Bridge',
];

export const modes = [
  { id: 'free' },
  { id: 'inspiration' },
  { id: 'eyes-closed' },
];
